// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SlotBindingRequest } from './slotBindingRequest';

/**
 * Slot binding configurations. Empty list means slot is available for any event task authored by the lecturer.
 */
export type CreateSlotsRequestBindings = SlotBindingRequest[] | null;
